import { render, staticRenderFns } from "./VolumeByProductCategoryReport.vue?vue&type=template&id=e25d0e1a&"
import script from "./VolumeByProductCategoryReport.vue?vue&type=script&lang=js&"
export * from "./VolumeByProductCategoryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports